// extracted by mini-css-extract-plugin
export var act_like_span = "act_like_span-qZH";
export var link = "link-KZO";